









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ForgotPasswordLink extends Vue {
  @Prop({ required: true })
  readonly forgotPasswordRoute: string
}
